import React, { Component } from 'react';

class AboutMe extends Component {
    render() {
        return (
            <div className="col-lg-7 animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">
                <div className="flat-title t1">
                    <h4 className="sub-title mg-b22">About Me</h4>
                    <h2 className="title-section color-d12 mg-b41">Hi, I am here to help your next project!</h2>
                    <div className="description">
                        <p className="lt-sp01">
                        Hi, if you need  PSD template, landing page or Website design within a day? then you can tell me, I'm here to help you. I can design any kind of PSD template. Check my portfolio.
                        </p>
                        <p className="lt-sp01">
                        If you need  PSD template, landing page or Website design within a day? then you can tell me, I'm here to help you. I can design any kind of PSD template. Check my portfolio.
                        </p>
                    </div>
                    <h3 className="email position-relative">yourmail@email.com</h3>
                </div>
            </div>
        );
    }
}

export default AboutMe;
